import { get, post, put, destroy } from "./base";

const SubCategoryServ = {
    index: (params) => get("/sub-categories", { params }),
    single: (id) => get(`/sub-categories/${id}`),
    create: (payload) => post("/sub-categories", payload),
    update: (id, payload) => put(`/sub-categories/${id}`, payload),
    remove: (id) => destroy(`/sub-categories/${id}`),
    uploadImage: (formData) => post("/upload/category", formData)
};

export default SubCategoryServ;
